import React from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { CalendarIcon, ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import type { Course } from '../../types/content';
import { upcomingClasses } from '../../data/classes';
import { BOOKING_URL, CALENDAR_URL, SITE } from '../../data/site';
import { priceLabel } from '../../utils/courses';
import { ButtonLink } from '../ui/ButtonLink';
export function BookingSidebar({
  course
}: {
  course: Course;
}) {
  const sessions = upcomingClasses.filter(s => s.courseSlug === course.slug).slice(0, 3);
  return <aside className="overflow-hidden rounded-[4px] bg-white ring-1 ring-navy/10 shadow-[0_20px_50px_-24px_rgba(16,32,72,0.45)]" aria-label="Book this course" data-id="element-42" data-mp="2lbd03wys2xmi">
      <div className="bg-navy p-6 text-white" data-id="element-43" data-mp="2ga76lwxan6bx">
        <p className="text-sm text-chrome-300" data-id="element-44" data-mp="qy4x3i0nffps">Tuition</p>
        <p className="font-display text-5xl font-bold" data-id="element-45" data-mp="lxz49yin7n64">{priceLabel(course)}</p>
      </div>
      <div className="space-y-5 p-6" data-id="element-46" data-mp="m0bvl2aaj9vu">
        <ul className="space-y-3 text-[15px] text-ink" data-id="element-47" data-mp="2l9c40uleix9o">
          <li className="flex gap-3" data-id="element-48" data-mp="2l6puwqiv49pc">
            <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-49" data-mp="2q6ufosqszqld" /> {course.duration}
          </li>
          <li className="flex gap-3" data-id="element-50" data-mp="2u8fpu6bydqrv">
            <CalendarIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-51" data-mp="2u7edzzn45093" /> {course.schedule}
          </li>
          <li className="flex gap-3" data-id="element-52" data-mp="33zk22ya8uxj0">
            <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-53" data-mp="33yin4iq3xqw0" /> {SITE.location.venue}
          </li>
        </ul>
        {sessions.length > 0 && <div data-id="element-54" data-mp="3dy9moytiyw2y">
            <p className="text-sm font-semibold text-navy" data-id="element-55" data-mp="3dxq2tckbdxma">Next dates</p>
            <ul className="mt-2 divide-y divide-navy/10 border-y border-navy/10" data-id="element-56" data-mp="3hz39tpz586us">
              {sessions.map(s => <li key={s.id} className="flex items-center justify-between py-2.5 text-sm" data-id="element-57" data-mp="1jkibhuvjs45e">
                  <span className="font-medium text-ink" data-id="element-58" data-mp="1nlk5nxalxq0i">{format(parseISO(s.date), 'EEE, MMM d')}</span>
                  <span className={s.seatsLeft <= 3 ? 'font-semibold text-accent' : 'text-steel'} data-id="element-59" data-mp="2qwhk25bpw80h">{s.seatsLeft} seats left</span>
                </li>)}
            </ul>
          </div>}
        <ButtonLink href={BOOKING_URL} size="lg" className="w-full" data-id="element-60" data-mp="2zxxq60vi1nyw">
          Book Now
        </ButtonLink>
        <ButtonLink href={SITE.phoneHref} variant="outline-dark" className="w-full" data-id="element-61" data-mp="2vtho6ap0b0oy">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-62" data-mp="39szg2yxlmu2j" /> {SITE.phoneDisplay}
        </ButtonLink>
        <div className="flex items-center justify-between text-sm" data-id="element-63" data-mp="34uxxef434wrl">
          <a href={CALENDAR_URL} className="font-semibold text-navy underline-offset-4 hover:underline" data-id="element-64" data-mp="3jkn40puy5sz9">
            Full calendar
          </a>
          <Link to="/packages" className="font-semibold text-navy underline-offset-4 hover:underline" data-id="element-65" data-mp="3endgxgv15tel">
            Save with a package
          </Link>
        </div>
      </div>
    </aside>;
}